import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
export interface FamilyOfficeMasterState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allFamilyOfficeMaster: [] | null | any;
}
const initialState: FamilyOfficeMasterState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allFamilyOfficeMaster: null,
};
export const familyOfficeMasterSlice = createSlice({
  name: 'FamilyOfficeMaster',
  initialState,
  reducers: {
    setAllFamilyOfficeMaster: (state, action) => {
      state.allFamilyOfficeMaster = action.payload.data;
    },
    setFamilyOfficeMaster: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllFamilyOfficeMasterBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});
// Action creators are generated for each case reducer function
export const { setAllFamilyOfficeMaster, setFamilyOfficeMaster, setAllFamilyOfficeMasterBySearch,reset } = familyOfficeMasterSlice.actions;
export const allFamilyOfficeMasterDetails = (state: RootState) => state.familyOfficeMaster.allFamilyOfficeMaster;
export const getAllFamilyOfficeMasterDetails = (state: RootState) => state.familyOfficeMaster.data;
export const getFamilyOfficeMasterTotalRecords=(state:RootState)=>state.familyOfficeMaster.totalRecords;
export const getAllFamilyOfficeMasterBySearch = (state: RootState) => state.familyOfficeMaster.data;
export default familyOfficeMasterSlice.reducer;